<!-- 发布评估 -->
<template>
  <div class="yxtbiz-create-eval__publish">
    <eval-notify
      ref="evalNotify"
      :id="id"
      :noTiming="noTiming"
      @get-info="getInfo"
    />

    <yxtbiz-eval-step-footer :operation="operation" footer-width="960px" />
  </div>
</template>

<script>
import handleError from './handleError';
import { publishEval } from './service.js';
import evalStepFooter from './components/eval-step-footer';
import evalNotify from './components/eval-notify.vue';

export default {
  components: {
    yxtbizEvalStepFooter: evalStepFooter,
    evalNotify
  },
  mixins: [handleError],
  props: {
    canPublish: {
      type: Boolean
    },
    canSave: {
      type: Boolean
    },
    purposeId: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    sourceType: {
      type: Number
    },
    noTiming: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enabledSelf: 0, // 是否开启自我评价
      enabledLeader: 0, // 是否开启上级评价
      enabledEqual: 0, // 是否开启平级评价
      enabledSubordinate: 0, // 是否开启下级评价
      operation: {
        disabled: false,
        prev: this.prev,
        publishDisabled: false,
        publish: this.canPublish ? this.publish : false,
        primarySave: this.canSave ? this.save : false,
        saveText: this.$t('pc_gwnl_global_btn_saveEval' /* 保存评估 */)
      }
    };
  },
  computed: {
    messageTemplateList() {
      let list = [];
      if (this.enabledSelf === 1) {
        list.push({
          label: this.$t('pc_gwnl_eval_selfEvalNews'),
          visible: 'selfVisible',
          code: 'gwnl_eval_self'
        });
      }
      if (this.enabledLeader === 1) {
        list.push({
          label: this.$t('pc_gwnl_eval_leaderEvalNews'),
          visible: 'leaderVisible',
          code: 'gwnl_eval_leader'
        });
      }
      if (this.enabledEqual === 1) {
        list.push({
          label: this.$t('pc_gwnl_eval_equalEvalNews'),
          visible: 'equalVisible',
          code: 'gwnl_eval_equal'
        });
      }
      if (this.enabledSubordinate === 1) {
        list.push({
          label: this.$t('pc_gwnl_eval_subordinateEvalNews'),
          visible: 'subordinateVisible',
          code: 'gwnl_eval_subordinate'
        });
      }
      return list;
    }
  },

  methods: {
    save() {
      this.publishEval(0);
    },
    prev() {
      this.$emit('prev');
    },
    publish() {
      this.publishEval(1);
    },

    getInfo(res) {
      this.enabledSelf = res.enabledSelf;
      this.enabledLeader = res.enabledLeader;
      this.enabledEqual = res.enabledEqual;
      this.enabledSubordinate = res.enabledSubordinate;
    },

    publishEval(publish = 1) {
      this.$refs.evalNotify.validateForm(() => {
        this.postPublish(publish);
      });
    },
    postPublish(publish) {
      if (publish === 0) {
        this.operation.disabled = true;
      } else {
        this.operation.publishDisabled = true;
      }
      let data = this.$refs.evalNotify.getPublishParams();
      data.publish = publish;

      publishEval(this.id, data)
        .then(() => {
          this.$message.success(
            publish === 1
              ? this.$t('pc_gwnl_global_msg_publishSuccessful')
              : this.$t('pc_gwnl_global_msg_savedSuccessfully')
          );
          this.operation.disabled = false;
          this.operation.publishDisabled = false;
          if (publish === 1) {
            this.$emit('publish');
          }

          this.$emit('save');
        })
        .catch(err => {
          this.operation.disabled = false;
          this.operation.publishDisabled = false;
          this.handleError(err);
        });
    }
  }
};
</script>
